import { Svg } from 'components/Svg'
import loadingIcon from 'assets/loading.svg'

export const LoadingFullScreen = () => {
  return {
    view ({ attrs: { style } }) {
      return m('.inset-0.flex.flex-col.flex-grow.justify-center.items-center.h-full.w-full', {
        key: 'loading',
        style
      }, [
        m('', [
          m(Svg, {
            classes: ['w-12', 'text-gray-400', 'rotate', 'm-auto']
          }, loadingIcon)
        ])
      ])
    }
  }
}
